import styles from "./StudyContent.module.scss";
import {Project} from "../../types/Project";
import {Query} from "../HealthcareUsageReport/types/CohortQuery";
import React, {useRef} from "react";
import {StudyTitles} from "./StudyTitles";
import {DatasetPicker} from "./DatasetPicker/DatasetPicker";

type StudyActionsProps = {
    primaryAction?: JSX.Element,
    secondaryAction?: JSX.Element,
    project: Project,
    study: Query,
    showDatasetPicker?: boolean
}

export const StudyActions: React.FC<StudyActionsProps> = ({
    primaryAction,
    secondaryAction,
    project,
    study,
    showDatasetPicker = true
}) => {
    const rowRef = useRef<HTMLDivElement>(null)
    const width = rowRef?.current?.getBoundingClientRect()?.width ?? 0

    return <div ref={rowRef} className={styles['actions-parent']}>
        <StudyTitles containerWidth={width} project={project} study={study}/>
        <div className={styles['actions']}>
            {showDatasetPicker && <DatasetPicker query={study}/>}
            {secondaryAction === undefined ? null : <>{secondaryAction}</>}
            {primaryAction}
        </div>
    </div>
}